<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Negociações em andamento</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <b-button
              v-if="countFilter > 0"
              variant="primary"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </b-button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Negociações em andamento</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      aria-labelledby="dropdownMenuButton"
                      class="dropdown-menu"
                      id="dropTableOptions"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader
                            :small="true"
                            :isLoading="loadingReport"
                          ></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">
                      {{ labelName }}
                    </th>
                    <th scope="col" class="border-0 text-left">Contato</th>
                    <th scope="col" class="border-0 text-left">Parceiro</th>
                    <th scope="col" class="border-0">Proposta gerada</th>
                    <th scope="col" class="border-0">Expira em</th>
                    <th
                      scope="col"
                      class="border-0"
                      v-if="
                        $isAuthorize('Prospect', 'Get') ||
                        $isAuthorize('ProspectProposal', 'Get')
                      "
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(prospect, index) in prospects" :key="index">
                    <td></td>
                    <td class="text-left td-with-subs">
                      <div>{{ prospect.Name | substring(50) }}</div>
                      <span>{{ prospect.Identity | identity }}</span>
                    </td>
                    <td class="text-left">{{ prospect.ContactName }}</td>
                    <td class="text-left">{{ prospect.Partner.Name }}</td>
                    <td>
                      <i :class="[GetSendClass(prospect.IsSendProposal)]"></i>
                    </td>
                    <td>
                      <span
                        :class="[GetSpanClass(prospect.DaysToExpiration)]"
                        >{{
                          GetExpirationDaysLegend(prospect.DaysToExpiration)
                        }}</span
                      >
                    </td>
                    <td
                      v-if="
                        $isAuthorize('Prospect', 'Get') ||
                        $isAuthorize('ProspectProposal', 'Get')
                      "
                    >
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('Prospect', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="GetProspect($event, prospect.Id)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="
                              !prospect.IsRemoved &&
                              $isAuthorize('Training', 'List')
                            "
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              OpenProspectTrainings($event, prospect.Id)
                            "
                          >
                            <i class="fas fa-headset mr-2"></i>
                            Reuniões
                          </a>
                          <a
                            v-if="$isAuthorize('ProspectProposal', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              OpenProspectProposal($event, prospect.Id)
                            "
                          >
                            <i class="fas fa-check mr-2"></i>
                            Gerar proposta
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      prospects == undefined ||
                      prospects == null ||
                      prospects.length == 0
                    "
                  >
                    <td colspan="7">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      :size="HasProspectProposals ? 'lg' : ''"
      id="mFormProspect"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- TABS -->
      <nav v-if="!loadingModal" class="nav-steps" aria-label="breadcrumb">
        <ol
          style="background-color: #fff; padding: 0.75rem 0rem"
          class="breadcrumb"
        >
          <li class="breadcrumb-item">
            <a
              class="black-text"
              href="#"
              v-on:click="GoToStep($event, 0)"
              :class="[mCurrentStep == 0 ? 'active' : '']"
              >Prospect</a
            >
          </li>
          <li class="breadcrumb-item" v-if="HasNotes">
            <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>
            <a
              class="black-text"
              href="#"
              v-on:click="GoToStep($event, 1)"
              :class="[mCurrentStep == 1 ? 'active' : '']"
              >Notas</a
            >
          </li>
          <li class="breadcrumb-item" v-if="HasProspectProposals">
            <i class="fas fa-angle-right mx-2" aria-hidden="true"></i>
            <a
              class="black-text"
              href="#"
              v-on:click="GoToStep($event, 2)"
              :class="[mCurrentStep == 2 ? 'active' : '']"
              >Propostas</a
            >
          </li>
        </ol>
      </nav>
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <div v-if="mCurrentStep === 0">
          <!-- MerchantType.Code -->
          <d-form-row>
            <d-col sm="12" class="form-group">
              <label>Tipo de conta</label>
              <d-select
                v-model="infoProspect.MerchantType.Code"
                :disabled="true"
              >
                <option :value="null">Selecione</option>
                <option :value="2">Pessoa jurídica</option>
                <option :value="3">Marketplace</option>
              </d-select>
            </d-col>
          </d-form-row>
          <!-- Name -->
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>{{ labelName }}</label>
              <d-form-input
                type="text"
                v-model="infoProspect.Name"
                :disabled="true"
              />
            </d-col>
            <!-- Identity -->
            <d-col md="6" class="form-group">
              <label>CNPJ</label>
              <the-mask
                class="form-control"
                type="tel"
                :mask="['###.###.###-##', '##.###.###/####-##']"
                v-model="infoProspect.Identity"
                :disabled="true"
              />
            </d-col>
          </d-form-row>
          <!-- ContactName -->
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Nome do contato</label>
              <d-form-input
                type="text"
                v-model="infoProspect.ContactName"
                :disabled="true"
              />
            </d-col>
            <!-- Phone -->
            <d-col md="6" class="form-group">
              <label for="phoneNumber">Telefone</label>
              <d-input-group seamless>
                <d-input-group-text slot="prepend">
                  <i class="fas fa-phone-alt"></i>
                </d-input-group-text>
                <the-mask
                  id="phoneNumber"
                  class="form-control"
                  type="tel"
                  :mask="['(##) #####-####', '(##) ####-####']"
                  v-model="infoProspect.Phone"
                  :disabled="true"
                />
              </d-input-group>
            </d-col>
          </d-form-row>
          <!-- Email -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label for="feEmail">E-mail</label>
              <d-form-input
                type="email"
                v-model="infoProspect.Email"
                :disabled="true"
              />
            </d-col>
          </d-form-row>
        </div>
        <!-- NOTES -->
        <div v-if="mCurrentStep === 1">
          <notes-slider :value="infoProspect.ProspectNotes"></notes-slider>
        </div>
        <!-- PROPOSALS -->
        <div v-if="mCurrentStep === 2">
          <table class="table mb-0" v-if="HasProspectProposals">
            <thead class="bg-s2p-gray-light">
              <tr>
                <th scope="col" class="border-0"></th>
                <th scope="col" class="border-0">Sequência</th>
                <th scope="col" class="border-0">Data de emissão</th>
                <th scope="col" class="border-0">Data de validade</th>
                <th scope="col" class="border-0 text-left">Título</th>
                <th scope="col" class="border-0 text-left">Gerado por</th>
                <th scope="col" class="border-0"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(prospectProposal, index) in prospectProposals"
                :key="index"
              >
                <td></td>
                <td>{{ prospectProposal.Code }}</td>
                <td>{{ prospectProposal.EmissionDate | date }}</td>
                <td>{{ prospectProposal.DueDate | date }}</td>
                <td class="text-left">{{ prospectProposal.Title }}</td>
                <td class="text-left">{{ prospectProposal.UserName }}</td>
                <td>
                  <b-button
                    class="btn btn-outline-secondary btn-sm"
                    v-b-tooltip.hover
                    title="Visualizar proposta"
                    v-on:click="
                      OpenProspectProposalDisabled($event, prospectProposal.Id)
                    "
                  >
                    <i class="fas fa-eye mr-0"></i>
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button-group v-if="HasNotes || HasProspectProposals">
          <b-button
            size="sm"
            class="btn btn-secondary"
            @click="BackStep()"
            :disabled="mCurrentStep === 0"
          >
            <i class="fas fa-arrow-left"></i>
          </b-button>
          <b-button
            size="sm"
            class="btn btn-secondary"
            @click="NextStep()"
            :disabled="
              mCurrentStep === 2 ||
              (mCurrentStep === 1 && !HasProspectProposals)
            "
          >
            <i class="fas fa-arrow-right"></i>
          </b-button>
        </b-button-group>
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFormProspectProposal"
      :title="modalProposalTitle"
      size="lg"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <!-- Loader -->
      <div v-if="loadingProposal">
        <loader :is-loading="loadingProposal"></loader>
      </div>
      <div v-else>
        <d-form-row>
          <d-col md="4" class="form-group">
            <label>Título</label>
            <d-form-input
              type="text"
              :value="infoProspectProposal.Title"
              :disabled="true"
            />
          </d-col>
          <d-col md="4" class="form-group">
            <label>Data de emissão</label>
            <date-field
              v-model="infoProspectProposal.EmissionDate"
              :disabled="true"
            />
          </d-col>
          <d-col md="4" class="form-group">
            <label>Data de validade</label>
            <date-field
              v-model="infoProspectProposal.DueDate"
              :minDate="infoProspectProposal.EmissionDate"
              :disabled="isSeeingProspectProposal"
            />
          </d-col>
        </d-form-row>

        <d-form-row>
          <d-col md="12" class="form-group">
            <label>Introdução</label>
            <b-form-textarea
              type="text"
              rows="1"
              v-model="infoProspectProposal.Text"
              :disabled="isSeeingProspectProposal"
            />
          </d-col>
        </d-form-row>

        <d-form-row>
          <d-col md="12" class="form-group">
            <label
              v-b-tooltip.hover
              title="Texto da proposta que será gerado automaticamente."
              >Descrição</label
            >
            <b-form-textarea
              type="text"
              readonly
              :rows="isSeeingProspectProposal ? 18 : 8"
              :value="infoProspectProposal.PaymentMethod"
            />
          </d-col>
        </d-form-row>

        <d-form-row>
          <d-col md="6" class="form-group" v-if="!isSeeingProspectProposal">
            <label>Método de pagamento</label>
            <d-select
              v-model="activePaymentMethod"
              :value="null"
              :disabled="loadingGenerate"
            >
              <option :value="null" selected>Selecione</option>
              <option
                v-for="pymt in PaymentMethods"
                v-bind:key="pymt.Code"
                v-bind:value="pymt.Code"
              >
                {{ pymt.Name }}
              </option>
            </d-select>
          </d-col>
          <d-col
            md="6"
            v-if="activePaymentMethod != null && !isSeeingProspectProposal"
            class="form-group"
          >
            <label v-if="activeTax.TaxType.Code == 1">Percentual</label>
            <label v-else>Valor</label>
            <decimal-field
              v-on:onchange="OnValueChange"
              v-on:onfocusout="OnFocusOut"
              :key="keyDecimalField"
              v-model="activeTax.Amount"
              :disabled="loadingGenerate"
              :type="activeTax.TaxType.Code == 1 ? 'percentage' : 'currency'"
            />
          </d-col>
        </d-form-row>

        <table
          class="table mb-0"
          :key="keyTable"
          v-if="!isSeeingProspectProposal && PaymentMethods.length > 0"
        >
          <thead class="bg-s2p-gray-light">
            <tr>
              <th>Método de Pagamento</th>
              <th>Taxa</th>
              <th class="text-center">Parcela inicial</th>
              <th class="text-center">Parcela final</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <template v-for="(tax, idxTax) in taxes">
              <tr v-bind:key="tax.PaymentMethod.Code + 'idx' + idxTax">
                <td
                  :rowspan="
                    ShouldBeRendered(tax) && tax.PaymentMethod.Code == 2
                      ? '3'
                      : ''
                  "
                  class="align-middle"
                  v-if="ShouldBeRendered(tax)"
                >
                  {{ tax.PaymentMethod.Name }}
                </td>
                <td v-if="tax.TaxType.Code == 1">
                  {{ tax.Amount | percentage }}
                </td>
                <td v-else>{{ tax.Amount | currency }}</td>
                <template v-if="tax.PaymentMethod.Code == 2">
                  <td class="text-center">{{ tax.InitialInstallment }}</td>
                  <td class="text-center">{{ tax.EndInstallment }}</td>
                </template>
                <template v-else>
                  <td class="text-center"></td>
                  <td class="text-center"></td>
                </template>
                <td class="text-right">
                  <b-button
                    @click="ConfirmRemovalPymtMethod(tax.PaymentMethod.Code)"
                    size="sm"
                    v-if="ShouldBeRendered(tax, true)"
                    variant="outline-secondary"
                  >
                    <i class="fas fa-trash-alt" />
                  </b-button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="GetProspectProposalUrl()"
          :disabled="loadingGenerate || loadingModal"
        >
          <template v-if="!loadingGenerate">
            Gerar
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingGenerate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity"
            v-bind:placeholder="labelIdentity"
            v-on:keyup.enter.native="Filter()"
          />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <d-select
            v-model="filter.Partner.Id"
            :value="null"
            :disabled="idPartner > 0"
          >
            <option :value="null" selected>Parceiro</option>
            <option
              v-for="partner in partners"
              v-bind:value="partner.Id"
              v-bind:key="partner.Id"
            >
              {{ partner.Name }}
            </option>
          </d-select>
        </d-col>
        <d-col md="6" class="form-group">
          <d-select v-model="filter.CodeMerchantType" :value="null">
            <option :value="null" selected>Tipo de conta</option>
            <option :value="1">Pessoa física</option>
            <option :value="2">Pessoa jurídica</option>
          </d-select>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import DecimalField from "../common/decimal-field.vue";
import dateField from "../common/date-field";
import notesSlider from "../common/notes-slider";
import { hasValue } from "../../utils/functions.js";
export default {
  name: "prospects",
  components: {
    DecimalField,
    dateField,
    notesSlider,
  },
  data: function () {
    return {
      PaymentMethods: [],
      Prospects: [],
      activePaymentMethod: null,
      activeTax: {
        Amount: null,
        TaxType: {
          Code: 1,
        },
      },
      keyDecimalField: 0,
      keyTable: 0,
      loadingList: false,
      loadingModal: false,
      loadingProposal: false,
      loadingGenerate: false,
      loadingReport: false,
      isSeeingProspectProposal: false,
      countFilter: 0,
      idPartner: 0,
      labelName: "Empresa",
      labelIdentity: "CNPJ",
      modalTitle: "Detalhes do prospect",
      modalProposalTitle: "Proposta",
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      filter: {
        Name: null,
        Identity: null,
        CodeMerchantType: null,
        Partner: {
          Id: null,
        },
      },
      prospects: [],
      partners: [],
      prospectProposals: [],
      taxesMaxMin: [],
      taxes: [],
      configurationTaxes: [],
      infoProspect: {
        Name: null,
        Identity: null,
        Email: null,
        Phone: null,
        ContactName: null,
        ExpirationDate: null,
        MerchantType: {
          Code: null,
        },
        ProspectNotes: [],
      },
      infoProspectProposal: {
        Code: null,
        Title: null,
        Text: null,
        PaymentMethod: null,
        EmissionDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        DueDate: this.$options.filters.date(
          this.$options.filters.addMonth(new Date(), 1),
          "YYYY-MM-DD"
        ),
        UserInternal: null,
        UserPartner: null,
        Prospect: null,
        IsOnlyGenerate: false,
      },
      mCurrentStep: 0,
      mSteps: ["prospect", "notes", "proposals"],
      hasErrorOnProposals: null,
      promises: [],
    };
  },
  computed: {
    HasNotes() {
      return (
        this.infoProspect.ProspectNotes != null &&
        this.infoProspect.ProspectNotes.length > 0 &&
        this.infoProspect.ProspectNotes[0].Description != ""
      );
    },
    HasProspectProposals() {
      return (
        this.prospectProposals != null && this.prospectProposals.length > 0
      );
    },
  },
  watch: {
    activePaymentMethod: function (nv, ov) {
      if (nv != null) {
        const idxPymtMethod = this.taxes.findIndex((elm) => {
          return nv == elm.PaymentMethod.Code;
        });
        this.activeTax = this.taxes[idxPymtMethod];
        if (nv != ov) {
          this.keyDecimalField += 1;
        }
      }
    },
    "activeTax.Amount": function (nv, ov) {
      if (nv != null && nv != ov && !this.modifyingProposal) {
        this.modifyingProposal = true;
        setTimeout(() => {
          this.GetPaymentMethod();
        }, 500);
        this.modifyingProposal = false;
      }
    },
    "pagination.PageNumber": function () {
      this.ListProspect();
    },
    "pagination.RowsPerPage": function () {
      this.ListProspect();
    },
  },
  beforeMount() {
    let params = this.$route.query;
    if (params != null && params.idPartner) {
      this.idPartner = parseInt(params.idPartner, 10);
    }
    
    this.$store
      .dispatch("ListCalculatorCommissionCompetence", {
        "Object.PartnerType.Code": 1,
      })
      .then((resp) => {
        resp.forEach((elm) => {
          let max = null;
          let min = 100;
          elm.CommissionCompetence.forEach((tax) => {
            if (tax.Tax > max) max = tax.Tax;
            if (tax.Tax < min) min = tax.Tax;
          });
          this.taxesMaxMin.push({
            PaymentCode: elm.PaymentMethod.Code,
            MaxValue: max,
            MinValue: min,
          });
        });
      })
      .catch((error) => {
        this.$makeToast(
          "Não foi possível buscar a lista de comissões",
          "danger",
          "Lista de Comissões",
          error
        );
      });
  },
  mounted() {
    if (this.idPartner > 0) this.filter.Partner.Id = this.idPartner;
    this.ListProspect();
    this.ListPartner();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListProspect();
    },
    GetSpanClass: function (daysToExpiration) {
      let variation = "badge badge-danger";
      if (daysToExpiration > 20) {
        variation = "badge badge-success";
      } else if (daysToExpiration > 10 && daysToExpiration <= 20) {
        variation = "badge badge-warning";
      }
      return variation;
    },
    GetSendClass: function (isSendProposal) {
      return isSendProposal ? "fas fa-check fa-green" : "fas fa-minus";
    },
    ListProspect: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.Partner.Id)) this.countFilter++;
      if (hasValue(this.filter.CodeMerchantType)) this.countFilter++;
      this.loadingList = true;
      let data = this.GetParamsData();
      this.$store
        .dispatch("ListProspect", { params: data })
        .then((response) => {
          this.prospects = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os prospects",
            error
          );
        })
        .finally(() => {
          this.loadingList = false;
        });
    },
    ListPartner: function () {
      let data = { OrderByColumn: "Name" };
      this.$store
        .dispatch("ListPartner", { params: data })
        .then((response) => {
          this.partners = response.Objects;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao obter lista de parceiros",
            error
          );
        });
    },
    ListProspectProposal: function (id) {
      this.$store
        .dispatch("ListProspectProposal", { id: id })
        .then((response) => {
          this.prospectProposals = response;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar as propostas",
            error
          );
        });
    },
    NextStep: function () {
      if (this.mCurrentStep < this.mSteps.length - 1) {
        if (this.mCurrentStep == 0 && !this.HasNotes) {
          this.mCurrentStep += 2;
        } else this.mCurrentStep += 1;
      }
    },
    BackStep: function () {
      if (this.mCurrentStep >= 1) {
        if (this.mCurrentStep == 2 && !this.HasNotes) {
          this.mCurrentStep -= 2;
        } else {
          this.mCurrentStep -= 1;
        }
      }
    },
    GoToStep: function (e, stepToGo) {
      e.preventDefault();
      if (stepToGo < this.mSteps.length && stepToGo >= 0) {
        this.mCurrentStep = stepToGo;
      }
    },
    GetParamsData: function (deletePagination = false) {
      let data = {
        ...this.pagination,
        ...{
          "Object.Name": this.filter.Name,
          "Object.Identity": this.filter.Identity,
          "Object.Partner.Id": this.filter.Partner.Id,
          "Object.MerchantType.Code": this.filter.CodeMerchantType,
        },
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.RowsPerPage;
        delete data.PageNumber;
      }
      return data;
    },
    RemovePaymentMethod: function (pymtCode) {
      this.taxes = this.taxes.filter((elm) => {
        return pymtCode != elm.PaymentMethod.Code;
      });

      this.PaymentMethods = this.PaymentMethods.filter((elm) => {
        return pymtCode != elm.Code;
      });

      this.keyTable += 1;
      this.activePaymentMethod = null;
      this.GetPaymentMethod();
    },
    ResetFilter: function () {
      this.filter = {
        Name: null,
        Identity: null,
        Partner: {
          Id: this.idPartner > 0 ? this.idPartner : null,
        },
        CodeMerchantType: null,
      };
      this.ListProspect();
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("ReportProspect", { params: data })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    ResetInfoProspect: function () {
      this.mCurrentStep = 0;
      this.prospectProposals = [];
      this.infoProspect = {
        Name: null,
        Identity: null,
        Email: null,
        Phone: null,
        ContactName: null,
        ExpirationDate: null,
        MerchantType: {
          Code: null,
        },
        ProspectNotes: [],
      };
    },
    ConfirmRemovalPymtMethod(pymtMethodCode) {
      const idxPymt = this.taxes.findIndex((elm) => {
        return elm.PaymentMethod.Code == pymtMethodCode;
      });
      let payment = this.taxes[idxPymt];

      this.$makeMsgBox(
        "Só será possivel adicionar novamente a forma de pagamento gerando uma nova proposta. " +
          "A descrição da forma de pagamento também será removida da proposta.",
        `Tem certeza que deseja remover o método de pagamento ${payment.PaymentMethod.Name}?`,
        this.RemovePaymentMethod,
        pymtMethodCode
      );
    },
    GetProspect: function (e, id) {
      e.preventDefault();
      this.loadingModal = true;
      this.ResetInfoProspect();
      this.$store
        .dispatch("GetProspect", { id: id })
        .then((response) => {
          this.infoProspect = response;
          this.ListProspectProposal(id);
          this.$bvModal.show("mFormProspect");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao carregar o prospect",
            error
          );
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },
    OnFocusOut: function () {
      let taxMaxMin = this.taxesMaxMin
        .filter((tax) => {
          return tax.PaymentCode == this.activePaymentMethod;
        })
        .shift();
      const curAmount = this.activeTax.Amount;

      // Check if the current amount is on the acceptable range.
      if (curAmount > taxMaxMin.MaxValue || curAmount < taxMaxMin.MinValue) {
        const idxPymt = this.taxes.findIndex((elm) => {
          return elm.PaymentMethod.Code == this.activePaymentMethod;
        });
        let pymt = this.taxes[idxPymt];

        // Change amount temporarily with the max or min value.
        let tempValue = null;
        if (curAmount > taxMaxMin.MaxValue) tempValue = taxMaxMin.MaxValue;
        if (curAmount < taxMaxMin.MinValue) tempValue = taxMaxMin.MinValue;
        this.activeTax.Amount = tempValue;
        this.keyDecimalField += 1;

        // Format values as Currency or Percentage
        let min,
          max,
          cur = null;
        if (pymt.TaxType.Code == 1) {
          min = this.$options.filters.percentage(taxMaxMin.MinValue);
          max = this.$options.filters.percentage(taxMaxMin.MaxValue);
          cur = this.$options.filters.percentage(curAmount);
        } else {
          min = this.$options.filters.currency(taxMaxMin.MinValue);
          max = this.$options.filters.currency(taxMaxMin.MaxValue);
          cur = this.$options.filters.currency(curAmount);
        }
        cur = cur ? `(${cur})` : "";

        this.$makeMsgBox(
          `Você inseriu um valor ${cur} fora do intervalo para o método de pagamento ` +
            `'${pymt.PaymentMethod.Name}'. O valor deve estar dentro do intervalo ` +
            `${min} - ${max}. Por favor contate o nosso suporte para maiores informações.`,
          `Confirmar valor fora do intervalo?`,
          this.ProcessValueOutInterval,
          curAmount
        );
      }
    },
    OnValueChange: function (newValue) {
      const idxPymt = this.taxes.findIndex((elm) => {
        return elm.PaymentMethod.Code == this.activePaymentMethod;
      });
      if (idxPymt != null) {
        if (this.taxes[idxPymt].PaymentMethod.Code == 2) {
          let lastValue = newValue;
          this.taxes.forEach((tax) => {
            if (tax.PaymentMethod.Code == 2 && tax.InitialInstallment != 1) {
              tax.Amount = lastValue + 0.5;
              lastValue += 0.5;
            }
          });
        }
      }
    },
    OpenProspectTrainings: function (e, id) {
      e.preventDefault();
      this.$router.push({
        name: "prospect-trainings",
        params: { idProspect: id },
      });
    },
    OpenProspectProposalDisabled: function (e, id) {
      e.preventDefault();
      this.loadingProposal = true;
      this.isSeeingProspectProposal = true;
      this.$bvModal.show("mFormProspectProposal");
      this.$store
        .dispatch("GetProspectProposal", { id: id })
        .then((response) => {
          this.infoProspectProposal = response;
          this.infoProspectProposal.IsOnlyGenerate = true;
          this.modalProposalTitle = `Proposta para ${this.infoProspectProposal.Prospect.Name}`;
        })
        .catch((error) => {
          this.loadingProposal = false;
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao buscar o prospect",
            error
          );
        })
        .finally(() => (this.loadingProposal = false));
    },
    OpenProspectProposal: function (e, id) {
      e.preventDefault();
      this.loadingProposal = true;
      this.isSeeingProspectProposal = false;
      this.activePaymentMethod = null;
      this.$bvModal.show("mFormProspectProposal");
      let userInternal = this.$getUserInternal();
      delete userInternal.Image;
      this.$store
        .dispatch("GetProspect", { id: id })
        .then((responseProspect) => {
          this.infoProspectProposal = {
            Code: responseProspect.CodeProspectProposal,
            Title: `Proposta PRO${responseProspect.CodeProspectProposal} - v1`,
            Text: null,
            PaymentMethod: null,
            EmissionDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
            DueDate: this.$options.filters.date(
              this.$options.filters.addMonth(new Date(), 1),
              "YYYY-MM-DD"
            ),
            UserInternal: userInternal,
            UserPartner: null,
            Prospect: responseProspect,
            IsOnlyGenerate: false,
          };
          this.modalProposalTitle = `Gerar proposta para ${this.infoProspectProposal.Prospect.Name}`;
          this.$store
            .dispatch("ListConfigurationTax", {})
            .then((response) => {
              let code = this.infoProspectProposal.Prospect.MerchantType.Code;
              this.configurationTaxes = response.Objects;
              let taxes = this.configurationTaxes.filter(function (confTax) {
                return confTax.MerchantType.Code == code;
              });
              this.taxes = taxes;

              this.PaymentMethods = [];
              let map = new Map();
              // Grab the payment methods and their indexes.
              taxes.forEach(
                function (tax) {
                  if (!map.has(tax.PaymentMethod.Code)) {
                    let pymtMethod = {
                      Code: tax.PaymentMethod.Code,
                      Name: tax.PaymentMethod.Name,
                    };
                    this.PaymentMethods.push(pymtMethod);
                    map.set(tax.PaymentMethod.Code, true);
                  }
                }.bind(this)
              );
              this.GetPaymentMethod();
            })
            .catch((error) => {
              this.$makeToast(
                undefined,
                "danger",
                "Erro carregar a lista de taxas.",
                error
              );
            })
            .finally(() => (this.loadingProposal = false));
        })
        .catch((error) => {
          this.loadingProposal = false;
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao buscar o prospect",
            error
          );
        });
    },
    ProcessValueOutInterval: function (amount) {
      this.activeTax.Amount = amount;
      this.keyDecimalField += 1;
      this.keyTable += 1;
    },
    ShouldBeRendered(tax, deleteBtn = false) {
      if (tax.PaymentMethod.Code != 2) return true;
      if (tax.PaymentMethod.Code == 2) {
        if (tax.InitialInstallment == 2 && deleteBtn) return true;
        if (tax.InitialInstallment == 1 && deleteBtn) return false;
        if (tax.InitialInstallment == 1) return true;
      }
      return false;
    },
    GetTextAmount: function (element, creditCard) {
      if (creditCard) {
        return ` (percentual por transação): ${this.$options.filters.percentage(
          element.Amount
        )}`;
      }
      return element.TaxType.Code == 1
        ? `- Percentual por transação: ${this.$options.filters.percentage(
            element.Amount
          )}`
        : `- Valor por transação: ${this.$options.filters.currency(
            element.Amount
          )}`;
    },
    GetTextCreditCard: function (element) {
      let text = "";
      if (element.InitialInstallment == element.EndInstallment) {
        text = `- Em ${element.InitialInstallment} ${
          element.InitialInstallment == 1 ? "vez" : "vezes"
        }`;
      } else {
        text = `- De ${element.InitialInstallment} até ${element.EndInstallment} vezes`;
      }
      return text + " " + this.GetTextAmount(element, true);
    },
    GetExpirationDaysLegend(days) {
      if (days == null) return "";
      if (days > 1) {
        return days + " dias";
      } else if (days > 0) {
        return days + " dia";
      } else {
        return "Hoje";
      }
    },
    GetText: function (element) {
      return (
        `<b>${element.PaymentMethod.Name}</b>` +
        "\n" +
        `${this.GetTextAmount(element, false)}` +
        "\n" +
        `${element.PaymentMethod.Description}` +
        `${element.PaymentMethod.Description !== "" ? "\n" : ""}`
      );
    },
    GetPaymentMethod: function () {
      let text = "";
      let textCreditCard = "";
      let textReturn = "";
      this.taxes.forEach((element) => {
        text = "";
        if (element.PaymentMethod.Code == "2") {
          textCreditCard =
            textCreditCard + "\n" + this.GetTextCreditCard(element);
          if (element.EndInstallment == 12) {
            text =
              `<b>${element.PaymentMethod.Name}</b>` +
              `${textCreditCard}` +
              "\n" +
              `${element.PaymentMethod.Description}` +
              "\n";
            textReturn = textReturn == "" ? text : textReturn + "\n" + text;
          }
        } else {
          text = this.GetText(element);
          textReturn = textReturn == "" ? text : textReturn + "\n" + text;
        }
      });
      this.infoProspectProposal.PaymentMethod = textReturn;
    },
    GetProspectProposalUrl: function () {
      this.loadingGenerate = true;
      this.$store
        .dispatch("GetProspectProposalUrl", this.infoProspectProposal)
        .then((response) => {
          if (
            response.UrlProposal != null &&
            response.UrlProposal != undefined &&
            response.UrlProposal != ""
          ) {
            this.ListProspect();
            this.$bvModal.hide("mFormProspectProposal");
            window.open(response.UrlProposal, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao gerar a proposta",
            error
          );
        })
        .finally(() => (this.loadingGenerate = false));
    },
  },
};
</script>

<style scoped>
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
.fa-green {
  color: #0ac37f;
}
.nav-steps .breadcrumb-item:before {
  content: none;
}
.nav-steps .breadcrumb-item .active {
  text-decoration: underline;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/prospects.vue